import * as yup from "yup";
import React, {Fragment, useEffect, useState} from "react";
import Breadcrumb from "../../../../layout/breadcrumb";
import {Alert, Card, CardBody, Col, Container, Form, FormGroup, Nav, Row} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import withReducer from "../../../../store/withReducer";
import productReducer from "../../store";
import PreLoader from "../../../../share-components/ui/preLoader";
import QaCategoryForm from "./qaCategoryForm";
import {
    addQaCategory,
    closeEditDialog,
    deleteQaCategory,
    getAllQaCategories,
    openEditDialog,
    openNewDialog,
    selectQaCategory,
    updateQaCategory
} from "../../store/qaCategorySlice";

const dataMenu = [
    {
        type: 0,
        text: 'Products',
        link: '/product'
    },
    {
        type: 1,
        text: 'Product Setting',
        link: ''
    },
    {
        type: 1,
        text: "Q&A Categories",
        link: ''
    }
];

const defaultValues = {
    id: '',
    title: '',
    sort_order: 0,
};

const schema = yup.object().shape({
    title: yup.string().required('You must enter a title'),
    sort_order: yup.number().typeError('Sort order must be a number').integer('Sort order must be a whole number'),
});

const QaCategory = () => {
    const dispatch = useDispatch();
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const qaCategory = useSelector(selectQaCategory);
    const [buttonDisable, setButtonDisable] = useState(false);

    useEffect(() => {
        dispatch(getAllQaCategories({title})).then(res => {
            if (!res.error) {
                setError('');
            } else {
                setError("Unable to load Q&A categories. Please try again.");
            }
            setLoading(false);
        });
    }, [dispatch, title]);

    const tableColumns = [
        {
            name: 'Title',
            selector: row => row.title,
            sortable: true,
            left: true,
        },
        {
            name: 'Sort Order',
            selector: row => row.sort_order,
            sortable: true,
            left: true,
        },
    ];

    const {handleSubmit, formState, reset, register, setValue, trigger, getValues} = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    const {errors} = formState;

    const onSubmitForm = (dialog, data) => {
        setButtonDisable(true);
        if (dialog.type === 'new') {
            dispatch(addQaCategory({...data})).then(res => {
                setButtonDisable(false);
                if (!res.error) closeDialog(dialog.type)
            });
        } else {
            dispatch(updateQaCategory({...data})).then(res => {
                setButtonDisable(false);
                if (!res.error) closeDialog(dialog.type);
            });
        }
    }

    const onEdit = (row) => {
        dispatch(openEditDialog(row));
    }

    const onDelete = (row) => {
        dispatch(deleteQaCategory(row.id))
    }

    const closeDialog = () => {
        dispatch(closeEditDialog());
    }

    return (
        <Fragment>
            <Container fluid={true} className="product-wrapper">
                {loading ? <><PreLoader></PreLoader></> : <>
                    <Breadcrumb data={dataMenu} title="Q&A Categories"/>
                    <div className="product-grid">
                        <div className="feature-products">
                            <Row>
                                <Col sm="12">
                                    <Card>
                                        <Row>
                                            <Col sm="6">
                                                <Nav tabs className="border-tab"></Nav>
                                            </Col>
                                            <Col sm="6">
                                                <div className='float-sm-right p-3'>
                                                    <a className="btn btn-sm btn-primary"
                                                       onClick={() => {
                                                           dispatch(openNewDialog())
                                                       }}
                                                    > <i className="fa fa-plus"></i> Add Item</a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col xl="12" sm="12">
                                    <Form>
                                        <FormGroup>
                                            <input onChange={(e) => setTitle(e.target.value)} name="title"
                                                   type="text" className="form-control"
                                                   placeholder="Search By Title"/>
                                        </FormGroup>
                                    </Form>
                                </Col>
                            </Row>
                            {error && (
                                <Row>
                                    <Col sm="12">
                                        <Alert color="danger">{error}</Alert>
                                    </Col>
                                </Row>
                            )}
                            <Row>
                                <Col sm="12">
                                    <Card>
                                        <CardBody>
                                            <div className="table-responsive product-table mt-4">
                                                <CommonDataTable
                                                    headerColumns={tableColumns}
                                                    gridData={qaCategory}
                                                    pagination
                                                    onEdit={onEdit}
                                                    onDelete={onDelete}
                                                />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </>}
            </Container>
            <ModalFormSubmit
                defaultValues={defaultValues}
                schema={schema}
                onSubmitForm={onSubmitForm}
                reset={reset}
                formState={formState}
                handleSubmit={handleSubmit}
                title="Q&A Category"
                selector='product'
                dialog={({product}) => product.qaCategory.addDialog}
                closeDialog={closeDialog}
                setValue={setValue}
                getValues={getValues}
                buttonDisable={buttonDisable}
            >
                <QaCategoryForm
                    errors={errors} register={register} setValue={setValue}
                    trigger={trigger} getValues={getValues}
                />
            </ModalFormSubmit>
        </Fragment>
    );
}

export default withReducer([{product: productReducer}])(QaCategory)
